import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/15.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonKirichenko = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Кириченко Лалита Николаевна</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Automation and Control, Master of Technical Sciences, PhD Student of Automation and Control
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57219992844'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'http://orcid.org/0000-0001-7069-5395'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», младший научный сотрудник, НИЦ «Industry 4.0»</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Научный сотрудник</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры (микросервисы).
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Докторант по теме «Разработка конвергентной системы мониторинга строительных конструкций». Опыт в COMSOL, MatLab, MathCAD, компьютерном моделировании.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP13067967 «Микропроцессорные устройства релейной защиты» (2022-2024) — завершён.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий» (2023-2025).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026).
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Mekhtiyev et al. Intelligent Fiber-Optic System for Monitoring Reinforced Concrete. Applied Sciences, 2023. [Scopus Q2]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Neftissov et al. Analysis of Air Emissions Detection Methods. Applied Sciences, 2024. [Scopus Q1]
                </MyText>
            </Flex>
        </Flex>
    );
};
